const gallery = [
  {
    src: require("../assets/gallery/Alma.jpg"),
    alt: "Alma Mater",
    caption: "Alma Mater by Lorado Taft",
  },
];

export { gallery };
